module.exports = __webpack_public_path__ + "img/gift3-01-c05.7b2fabec.png";